import { getItemModelCatalogId, getItemModelSellerId } from '@/redux/modules/item/summary/itemSummary.selectors';
import {
    LotRecommendationTrigger,
    LotRecommendationType,
    useTrackLotRecommendationClickedAnalytics,
} from '@/utils/analytics/item/trackLotRecommendationClicked.analytics';
import { useAppSelector } from '@/redux/hooks';
import { useCallback } from 'react';

type UseRecommendationTrackingProps = {
    itemId: number;
    recommendationPosition: number;
    recommendationType: LotRecommendationType;
};

export const useRecommendationTracking = ({
    itemId,
    recommendationPosition,
    recommendationType,
}: UseRecommendationTrackingProps) => {
    const trackLotRecommendationClicked = useTrackLotRecommendationClickedAnalytics();
    const catalogId = useAppSelector((state) => getItemModelCatalogId(state, itemId));
    const houseId = useAppSelector((state) => getItemModelSellerId(state, itemId));

    const onRecommendationClick = useCallback(
        (trigger: LotRecommendationTrigger) => {
            if (recommendationType) {
                trackLotRecommendationClicked({
                    catalogId,
                    houseId,
                    itemId,
                    lotClickPosition: recommendationPosition,
                    recommendationName: recommendationType,
                    trigger,
                });
            }
        },
        [catalogId, houseId, itemId, recommendationPosition, recommendationType, trackLotRecommendationClicked]
    );

    return {
        onRecommendationClick,
    };
};
